const LOCATION_NAME_RULES: Record<string, { regex: RegExp; style: string; hint: string }> = {
  header: {
    regex: /^[a-z0-9-]+$/,
    style: 'kebab-case',
    hint: 'Use lowercase letters, numbers, hyphens (e.g. x-api-key)',
  },
  query: {
    regex: /^[a-z][a-zA-Z0-9_]+$/,
    style: 'snake_case',
    hint: 'Start with lowercase, then letters, numbers, underscores (e.g. page_size)',
  },
  path: {
    regex: /^[a-z][a-z0-9-]*$/,
    style: 'kebab-case',
    hint: 'Start with lowercase, then lowercase letters, numbers, hyphens (e.g. user-id)',
  },
  body: {
    regex: /^[a-zA-Z][a-zA-Z0-9_-]*$/,
    style: 'standard naming',
    hint: 'Start with a letter, then other characters (e.g. user_id, apiKey)',
  },
};

export interface NameValidationError {
  message: string;
}

export const validateParameterName = (
  name: string,
  location: string
): NameValidationError | null => {
  if (!name) return null;

  const rule = LOCATION_NAME_RULES[location];
  if (!rule) return null;

  if (!rule.regex.test(name)) {
    return {
      message: `${rule.hint}`,
    };
  }

  return null;
};
